module.exports = __webpack_public_path__ + "img/logo.dca5d01a.png";